import { BOOST_PROPS } from './constants';

const boostQuery = data => {
  const { rawQueryStringified } = data;
  const parsedRawQuery = JSON.parse(rawQueryStringified);
  // eslint-disable-next-line no-undef
  if (!parsedRawQuery?.bool?.must[0]?.bool?.must) {
    return;
  }

  const { bool: { should: updatedShouldFilters } = {} } =
    parsedRawQuery.bool.must[0].bool.must.find(filter => filter.bool && filter.bool.should) || {};

  if (!updatedShouldFilters) return;

  let duplicateFilterFound = false;

  updatedShouldFilters.forEach(shouldFilter => {
    if (duplicateFilterFound) return;

    Object.keys(shouldFilter.match).forEach(key => {
      if (duplicateFilterFound) return;

      if (BOOST_PROPS[key]) {
        if (shouldFilter.match[key].boost) {
          // don't update if boost already exists as we have already added it
          duplicateFilterFound = true;
          return;
        }

        updatedShouldFilters.push({
          match: {
            [key]: {
              query: shouldFilter.match[key].query,
              boost: BOOST_PROPS[key]
            }
          }
        });
      }
    });
  });

  if (duplicateFilterFound) return;

  // eslint-disable-next-line no-param-reassign
  data.rawQueryStringified = JSON.stringify(parsedRawQuery);
};

export default boostQuery;
